import { Component } from '@angular/core';
import { BuscadorPage } from '../../pages/buscador/buscador';
import { MenuController, NavController } from 'ionic-angular';
import { FiltroPage } from '../../pages/filtro/filtro';

/**
 * Generated class for the CabeceraComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'cabecera',
  templateUrl: 'cabecera.html'
})
export class CabeceraComponent {

  constructor(public menuCtrl:MenuController, public navCtrl: NavController, ) {

  }

  goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }

  toggleMenu() {
    this.menuCtrl.toggle();
  }

  goToFiltro(){
    this.navCtrl.push(FiltroPage);
  }

}



// WEBPACK FOOTER //
// ./src/components/cabecera/cabecera.ts